import { IconFilter16 } from '@warp-ds/icons/react';
import { Button, Modal } from '@warp-ds/react';
import { useState } from 'react';
import type { Filters } from '@/domain';
import { Filter } from '@/scenes/resultPage/components/filters/Filter';

type TopBarProps = {
    filters: Filters;
    filterData: Record<string, unknown>;
    onFilterChanged: (filters: Filters) => void;
    className?: string;
};

export const FilterButton = ({ filters, filterData, onFilterChanged, className }: TopBarProps) => {
    const [showFilterModal, setShowFilterModal] = useState(false);

    return (
        <>
            <Button small utility onClick={() => setShowFilterModal(true)} className={className}>
                <IconFilter16 aria-hidden />
                Filter
            </Button>
            <Modal
                open={showFilterModal}
                title={<span className="t3">Filter</span>}
                onDismiss={() => setShowFilterModal(false)}
                footer={
                    <Button
                        primary
                        fullWidth
                        onClick={() => {
                            onFilterChanged(filters);
                            setShowFilterModal(false);
                        }}>
                        Bruk
                    </Button>
                }>
                <Filter onFilterChanged={onFilterChanged} filterData={filterData} filters={filters} />
            </Modal>
        </>
    );
};
